import { render } from "./ApprovalHistory.vue?vue&type=template&id=6a84e35e"
import script from "./ApprovalHistory.vue?vue&type=script&lang=js"
export * from "./ApprovalHistory.vue?vue&type=script&lang=js"

import "./ApprovalHistory.vue?vue&type=style&index=0&id=6a84e35e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ApprovalHistory.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a84e35e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a84e35e', __exports__)) {
    api.reload('6a84e35e', __exports__)
  }
  
  module.hot.accept("./ApprovalHistory.vue?vue&type=template&id=6a84e35e", () => {
    api.rerender('6a84e35e', render)
  })

}


export default __exports__